var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 2.5C6.42132 2.5 3.25 5.67132 3.25 9.58333C3.25 13.4954 6.42132 16.6667 10.3333 16.6667C14.2454 16.6667 17.4167 13.4954 17.4167 9.58333C17.4167 5.67132 14.2454 2.5 10.3333 2.5ZM0.75 9.58333C0.75 4.2906 5.0406 0 10.3333 0C15.6261 0 19.9167 4.2906 19.9167 9.58333C19.9167 14.8761 15.6261 19.1667 10.3333 19.1667C5.0406 19.1667 0.75 14.8761 0.75 9.58333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.333 3.33334C11.0234 3.33334 11.583 3.89299 11.583 4.58334V9.72641C11.583 9.7265 11.583 9.72632 11.583 9.72641C11.5831 9.83681 11.627 9.94293 11.7051 10.021L13.7169 12.0328C14.205 12.5209 14.205 13.3124 13.7169 13.8006C13.2287 14.2887 12.4373 14.2887 11.9491 13.8006L9.93759 11.789C9.93755 11.789 9.93764 11.7891 9.93759 11.789C9.39066 11.2422 9.08317 10.5004 9.08301 9.72694V4.58334C9.08301 3.89299 9.64265 3.33334 10.333 3.33334Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.080b84be3b4ff73e9fb1d16792278f4b.svg";
export { ForwardRef as ReactComponent };